import { IEditSubcategoryRestaurantPropertiesContext } from './editSubcategoryRestaurantPropertiesContext';

export enum EditSubcategoryRestaurantPropertiesActionTypes {
	REFETCH_REST_PROPS_DATA = 'REFETCH_REST_PROPS_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_DATA_FROM_RESTAURANT = 'SET_DATA_FROM_RESTAURANT',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	TOGGLE_AVAILABLE_FOR_REPETITION = 'TOGGLE_AVAILABLE_FOR_REPETITION',
	TOGGLE_IS_HIDDEN = 'TOGGLE_IS_HIDDEN',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchRestPropsData {
	type: EditSubcategoryRestaurantPropertiesActionTypes.REFETCH_REST_PROPS_DATA;
	payload: {
		needRefetchRestPropsData: IEditSubcategoryRestaurantPropertiesContext['needRefetchRestPropsData'];
	};
}

interface ISetAllData {
	type: EditSubcategoryRestaurantPropertiesActionTypes.SET_ALL_DATA;
	payload: {
		subcategoryId: IEditSubcategoryRestaurantPropertiesContext['subcategoryId'];
		subcategoryName: IEditSubcategoryRestaurantPropertiesContext['subcategoryName'];
		customerName: IEditSubcategoryRestaurantPropertiesContext['customerName'];
		categoryName: IEditSubcategoryRestaurantPropertiesContext['categoryName'];
		hasSchedulePriority: IEditSubcategoryRestaurantPropertiesContext['hasSchedulePriority'];
		activationSchedule: IEditSubcategoryRestaurantPropertiesContext['activationSchedule'];
		deactivationSchedule: IEditSubcategoryRestaurantPropertiesContext['deactivationSchedule'];
		fetchedRestaurants: IEditSubcategoryRestaurantPropertiesContext['fetchedRestaurants'];
	};
}

interface ISetIDRestaurant {
	type: EditSubcategoryRestaurantPropertiesActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IEditSubcategoryRestaurantPropertiesContext['IDSelectedRestaurant'];
		dishes: IEditSubcategoryRestaurantPropertiesContext['dishes'];
		activationSchedule: IEditSubcategoryRestaurantPropertiesContext['activationSchedule'];
		deactivationSchedule: IEditSubcategoryRestaurantPropertiesContext['deactivationSchedule'];
		availableForRepetition: IEditSubcategoryRestaurantPropertiesContext['availableForRepetition'];
		isHidden: IEditSubcategoryRestaurantPropertiesContext['isHidden'];
	};
}

interface ISetDataFromRestaurant {
	type: EditSubcategoryRestaurantPropertiesActionTypes.SET_DATA_FROM_RESTAURANT;
	payload: {
		dishes: IEditSubcategoryRestaurantPropertiesContext['dishes'];
		activationSchedule: IEditSubcategoryRestaurantPropertiesContext['activationSchedule'];
		deactivationSchedule: IEditSubcategoryRestaurantPropertiesContext['deactivationSchedule'];
		availableForRepetition: IEditSubcategoryRestaurantPropertiesContext['availableForRepetition'];
		isHidden: IEditSubcategoryRestaurantPropertiesContext['isHidden'];
	};
}

interface IChangeActivationSchedule {
	type: EditSubcategoryRestaurantPropertiesActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: IEditSubcategoryRestaurantPropertiesContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: EditSubcategoryRestaurantPropertiesActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: IEditSubcategoryRestaurantPropertiesContext['deactivationSchedule'];
	};
}

interface IToggleAvailableForRepetition {
	type: EditSubcategoryRestaurantPropertiesActionTypes.TOGGLE_AVAILABLE_FOR_REPETITION;
}

interface IToggleIsHidden {
	type: EditSubcategoryRestaurantPropertiesActionTypes.TOGGLE_IS_HIDDEN;
}

interface ISetDataForSubmit {
	type: EditSubcategoryRestaurantPropertiesActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditSubcategoryRestaurantPropertiesContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditSubcategoryRestaurantPropertiesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditSubcategoryRestaurantPropertiesContext['typeOfModalWindow'];
	};
}

export type TEditSubcategoryRestaurantPropertiesAction =
	| IRefetchRestPropsData
	| ISetAllData
	| ISetIDRestaurant
	| ISetDataFromRestaurant
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| IToggleAvailableForRepetition
	| IToggleIsHidden
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
